import React, { createContext, useReducer } from 'react'
import { RESET_LAYOUT, SET_HEADER_TRANSPARENCY } from 'constants/layout'

const LayoutContext = createContext({})

const initialState = {
  isHeaderTransparent: false,
}

function reducer(state, action) {
  switch (action.type) {
    case SET_HEADER_TRANSPARENCY:
      return {
        ...state,
        isHeaderTransparent: action.isHeaderTransparent,
      }
    case RESET_LAYOUT:
      return {
        ...initialState,
      }
    default:
      throw new Error()
  }
}

const LayoutProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState)

  return <LayoutContext.Provider value={{ state, dispatch }}>{children}</LayoutContext.Provider>
}

export { LayoutProvider, LayoutContext }
